<template>
  <div
    id="root"
    v-loading="(loading || loadingAll) && !isError"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
  >
    <div v-show="isError" class="alert alert-danger alert-dismissible fade show">
      <button
        type="button"
        aria-hidden="true"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="isError = !isError"
      >
        <i class="nc-icon nc-simple-remove" />
      </button>
      <span>
        <b>{{ error }}</b></span>
    </div>
    <div v-if="bibleStudy" v-show="!isError">
      <div class="container-fluid">
        <div class="row">
          <div v-if="!loadingAll" class="col-md-7 col-lg-7">
            <BS
              :bible-study="bibleStudy"
              v-if="bibleStudy"
            />
          </div>
          <div v-if="!loadingAll" class="col-md-5 col-lg-5">
            <BSP
              :bible-study="bibleStudy"
            />
          </div>
        </div>
        <div
          class="row"
          v-if="unsubmittedAttendances && bibleStudy.user_is_leader"
        >
          <div
            v-for="attendance in unsubmittedAttendances"
            :key="attendance.id"
            class="col-md-4"
          >
            <BSA
              :attendance="attendance"
              v-if="!loadingAll"
              ref="attendances"
            />
          </div>
        </div>
        <Pagination
          class="pull-right"
          v-if="!loadingAll && unsubmittedAttendances && bibleStudy.user_is_leader"
          v-model="currentPage"
          :per-page="itemsPerPage"
          :page-count="lastPage"
          @input="handlePageChanged"
        />
      </div>
      <BSAT
        v-if="!loadingAll"
        :bible-study="bibleStudy"
        :attendances="bibleStudyAttendancesAsc"
        :user-can-edit="bibleStudy.user_is_leader"
      >
        <template v-slot:paginator>
          <Pagination
            class="pull-right"
            v-if="!loading && !loadingAll"
            v-model="currentPage"
            :per-page="itemsPerPage"
            :page-count="lastPage"
            @input="handlePageChanged"
          />
        </template>
      </BSAT>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
    mapState, mapGetters, vuex
} from 'vuex';
import BibleStudy from '../../components/BibleStudy/BibleStudy';
import BibleStudyParticipants from '../../components/BibleStudy/Participant/Participants';
import BibleStudyAttendances from '../../components/BibleStudy/Attendance/Attendance';
import BibleStudyAttendanceTable from '../../components/BibleStudy/Attendance/Table';
import Pagination from '../../components/UIComponents/Pagination';

export default {
    app: '#root',
    components: {
        BSP: BibleStudyParticipants,
        BS: BibleStudy,
        BSA: BibleStudyAttendances,
        BSAT: BibleStudyAttendanceTable,
        Pagination
    },
    data() {
        return {
            namespace: 'BibleStudies',
            isError: false,
            bsLoading: false,
            bsaLoading: false,
            itemsPerPage: 39,
        };
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
            loading: (state) => state.BibleStudies.loading
        }),
        ...mapGetters({
            bibleStudy: 'BibleStudies/bibleStudyById',
            bibleStudyAttendances: 'BibleStudies/bibleStudyAttendancesById',
            bibleStudyAttendancesAsc: 'BibleStudies/bibleStudyAttendancesByIdAsc',
            unsubmittedAttendances: 'BibleStudies/unsubmittedAttendances'
        }),
        loadingAll() {
            return this.bsLoading || this.bsaLoading;
        },
        currentPage: {
            get() {
                return this.$store.state[this.namespace].BSAPagination.currentPage;
            },
            set(newPage) {
                this.$store.commit(`${this.namespace}/BSAPagination/setCurrentPage`, newPage);
            }
        },
        lastPage() {
            return this.$store.state[this.namespace].BSAPagination.lastPage;
        },
    },
    watch: {
        error() {
            if (this.error) {
                this.isError = true;
            } else {
                this.isError = false;
            }
        }
    },
    methods: {
        getBibleStudyById() {
            this.$store.dispatch(`${this.namespace}/getBibleStudyById`,
                { bibleStudyId: this.$route.params.id }).then(() => { this.bsLoading = false; }).catch((error) => {
                this.bsLoading = false;
            });
        },
        getBibleStudyAttendancesById() {
            this.$store.dispatch(`${this.namespace}/getBibleStudyAttendancesById`,
                { bibleStudyId: this.$route.params.id }).then(() => { this.bsaLoading = false; }).catch((error) => {
                this.bsaLoading = false;
            });
        },
        getCancelReasons() {
            this.$store.dispatch(`${this.namespace}/getCancelReasons`);
        },
        handlePageChanged(newPage) {
            this.currentPage = newPage;
            this.getBibleStudyAttendancesById();
        },
    },
    created() {
        this.$store.commit(`${this.namespace}/BSAPagination/setItemsPerPage`, this.itemsPerPage);
        this.$store.commit(`${this.namespace}/Pagination/setCurrentPage`, 1);
        // Only show full screen loading on page landing
        this.bsLoading = true;
        this.bsaLoading = true;
        this.getBibleStudyById();
        this.getBibleStudyAttendancesById();
        this.getCancelReasons();
    }
};
</script>

<style scoped>
#root {
    width: 100%;
}
</style>
